export const PoweredBySensorUp = () => (
  <a href='https://www.sensorup.com/' target='_blank' rel='noreferrer'>
    <img src='/assets/logo/SensorUp-Powered-by-2025.svg' alt='SensorUp' />
  </a>
)

PoweredBySensorUp.displayName = 'PoweredBySensorUp'
